import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=77ae62dc&scoped=true&"
import script from "./doctorList.vue?vue&type=script&lang=js&"
export * from "./doctorList.vue?vue&type=script&lang=js&"
import style0 from "./doctorList.vue?vue&type=style&index=0&id=77ae62dc&prod&lang=less&scoped=true&"
import style1 from "./doctorList.vue?vue&type=style&index=1&id=77ae62dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae62dc",
  null
  
)

export default component.exports